import { render } from "./profilmanager.vue?vue&type=template&id=0cc73372&scoped=true"
import script from "./profilmanager.vue?vue&type=script&lang=js"
export * from "./profilmanager.vue?vue&type=script&lang=js"

import "./profilmanager.vue?vue&type=style&index=0&id=0cc73372&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc73372"]])

export default __exports__